import type { PayloadAction } from '@reduxjs/toolkit';
import {
  type VendorPreferenceError,
  type VendorPreferencesState,
  vendorPreferencesInitialState,
} from 'src/redux/vendor-preferences/types';

const reducers = {
  // Switching the focused market invalidates the loaded tree and the eligible
  // caches (they're scoped to a single market). On a genuine market change we
  // reset to initial, then set the new ids. On the SAME id this is a pointer
  // no-op so we don't clobber an already-loaded tree.
  setActiveMarket: (state: VendorPreferencesState, action: PayloadAction<string | null>) => {
    const nextMarket = action.payload;
    if (nextMarket === state.activeMarketUuid) return;
    Object.assign(state, vendorPreferencesInitialState);
    state.activeMarketUuid = nextMarket;
    // marketUuid is set by fetchVendorPreferences.fulfilled once the tree loads;
    // here we only record the UI intent (activeMarketUuid).
  },

  setActiveCategory: (state: VendorPreferencesState, action: PayloadAction<string | null>) => {
    state.activeCategoryUuid = action.payload;
  },

  setActiveSubCategory: (state: VendorPreferencesState, action: PayloadAction<string | null>) => {
    state.activeSubCategoryUuid = action.payload;
  },

  resetVendorPreferences: (state: VendorPreferencesState) => {
    Object.assign(state, vendorPreferencesInitialState);
  },

  setConfigError: (state: VendorPreferencesState, action: PayloadAction<VendorPreferenceError>) => {
    state.configError = action.payload;
    state.isConfigLoading = false;
  },

  clearError: (
    state: VendorPreferencesState,
    action: PayloadAction<'config' | 'eligible' | 'save'>,
  ) => {
    if (action.payload === 'config') state.configError = null;
    else if (action.payload === 'eligible') state.eligibleError = null;
    else if (action.payload === 'save') state.saveError = null;
  },
};

export default reducers;
